'use client'

import { useState } from 'react'
import { Button } from './button'
import { Card } from './card'

interface TransactionHashProps {
  hash: string
  label?: string
  className?: string
}

export function TransactionHash({ hash, label = "Transaction Hash", className }: TransactionHashProps) {
  const [copied, setCopied] = useState(false)

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(hash)
      setCopied(true)
      setTimeout(() => setCopied(false), 2000)
    } catch (err) {
      console.error('Failed to copy:', err)
    }
  }

  const truncateHash = (hash: string) => {
    return `${hash.slice(0, 6)}...${hash.slice(-4)}`
  }

  const getExplorerUrl = (hash: string) => {
    return `https://sepolia.basescan.org/tx/${hash}`
  }

  return (
    <div className={`bg-muted/50 rounded-lg p-3 ${className}`}>
      <div className="flex items-center justify-between gap-2">
        <div className="min-w-0 flex-1">
          <p className="text-xs text-muted-foreground mb-1">{label}:</p>
          <div className="flex items-center gap-2">
            <code className="text-sm font-mono">{truncateHash(hash)}</code>
            <Button
              variant="ghost"
              size="sm"
              onClick={handleCopy}
              className="h-6 px-2 text-xs"
            >
              {copied ? '✓' : 'Copy'}
            </Button>
          </div>
        </div>
        <a
          href={getExplorerUrl(hash)}
          target="_blank"
          rel="noopener noreferrer"
          className="text-xs text-blue-500 hover:text-blue-600 transition-colors whitespace-nowrap"
        >
          View on BaseScan ↗
        </a>
      </div>
    </div>
  )
} 
